import axios from 'axios';

export const changePassword = (oldPassword, newPassword) =>
  axios
    .post('/api/change-password', { oldPassword, newPassword })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const getCompanyDetails = () =>
  axios
    .get('/api/get-company-details')
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const updateCompanyDetails = (companyDetails) =>
  axios
    .post('/api/update-company-details', companyDetails)
    .then((response) => response)
    .catch((error) => ({ success: false }));

export const updateQRcode = (qr) =>
  axios
    .post('/api/set-qr-code-version', qr, {headers: {"Content-Type": "text/plain"}})
    .then((response) => response)
    .catch((error) => ({ success: false }));

export const getQRcodeVersions = () =>
  axios
    .get('/api/get-qr-code-versions')
    .then((response) => response.data)
    .catch((error) => ({ success: false }));



// WEBPACK FOOTER //
// ./src/modules/account/_api.js